import { isRequiredText, strMax } from './utils';
export const validateHelpCategoryRadio = [
    isRequiredText('ご相談内容の種類を選択してください'),
];
export const validateHelpCategoryCheckbox = [
    (values) => (values || []).every((v) => !v) ? 'ご相談内容の種類を選択してください' : '',
];
export const validateDescription = [
    isRequiredText('ご相談内容の概要を入力してください'),
    strMax(10000, 'ご相談内容の概要は10000文字以内で入力してください'),
];
